export const getValueByPath = (obj, path) => {
  if (!obj || !path) {
    return undefined;
  }

  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

const normalizeLabelPart = (value) => {
  if (value === undefined || value === null) {
    return "";
  }

  if (typeof value === "string") {
    return value.trim();
  }

  if (typeof value === "number") {
    return `${value}`;
  }

  return "";
};

export const resolveListLabel = (item, labelField) => {
  const configuredFields = Array.isArray(labelField)
    ? labelField
    : [labelField].filter(Boolean);

  const configuredParts = configuredFields
    .map((field) => normalizeLabelPart(getValueByPath(item, field)))
    .filter(Boolean);

  if (configuredParts.length > 0) {
    return configuredParts.join(" ");
  }

  const nameParts = [
    getValueByPath(item, "translations.fa.name"),
    getValueByPath(item, "translations.fa.lastName"),
    getValueByPath(item, "translations.en.name"),
    getValueByPath(item, "translations.en.lastName"),
    item?.first_name,
    item?.last_name,
  ]
    .map(normalizeLabelPart)
    .filter(Boolean);

  if (nameParts.length > 0) {
    return nameParts.join(" ");
  }

  const fallbackFields = [
    "translations.fa.title",
    "translations.en.title",
    "translations.title",
    "translations.fa.name",
    "translations.en.name",
    "title",
    "name",
    "fa_name",
    "full_name",
    "email",
    "mobile",
    "phone",
  ];

  for (const field of fallbackFields) {
    const label = normalizeLabelPart(getValueByPath(item, field));
    if (label) {
      return label;
    }
  }

  return "";
};
